"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var libzl_1 = require("../libzl");
var utils_1 = require("../utils");
var CameraButton_1 = __importDefault(require("./CameraButton"));
var CameraButtons = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 30px;\n\ttop: 30px;\n\tz-index: 50;\n\tdisplay: flex;\n\tflex-direction: column;\n\tfloat: left;\n\n\t@media ", " {\n\t\tleft: 11px;\n\t\ttop: 11px;\n\t}\n\n\t@media ", " {\n\t\tposition: fixed;\n\t\tleft: 8px;\n\t\ttop: 8px;\n\t\tz-index: 850;\n\t}\n\n\n"], ["\n\tposition: absolute;\n\tleft: 30px;\n\ttop: 30px;\n\tz-index: 50;\n\tdisplay: flex;\n\tflex-direction: column;\n\tfloat: left;\n\n\t@media ", " {\n\t\tleft: 11px;\n\t\ttop: 11px;\n\t}\n\n\t@media ", " {\n\t\tposition: fixed;\n\t\tleft: 8px;\n\t\ttop: 8px;\n\t\tz-index: 850;\n\t}\n\n\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.fullScreenStream; });
var DebugButton = styled_components_1.default(components_1.IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", ";\n\tmargin-top: 8px;\n\tfont-size: 10px;\n"], ["\n\t", ";\n\tmargin-top: 8px;\n\tfont-size: 10px;\n"])), function (props) { return props.theme.camerabutton; });
var CameraControls = /** @class */ (function (_super) {
    __extends(CameraControls, _super);
    function CameraControls(props) {
        var _this = _super.call(this, props) || this;
        _this.changed = function (cam) {
            _this.setState(function (prevState) { return ({
                currentCamera: cam,
                splitButtons: __spreadArrays(prevState.splitButtons.map(function (i) {
                    if (i === _this.props.cameras.indexOf(cam)) {
                        return _this.props.cameras.indexOf(prevState.currentCamera);
                    }
                    return i;
                }))
            }); });
        };
        _this.getNextCamera = function () {
            var currCam = _this.state.currentCamera.split("_");
            var matches = function (c) {
                var s = c.split("_");
                for (var i = 0; i < Math.min(s.length, currCam.length); ++i) {
                    if (s[i] !== currCam[i]) {
                        return i;
                    }
                }
                return s.length;
            };
            var currCamIndex = _this.props.cameras.indexOf(__spreadArrays(_this.props.cameras).sort(function (l, r) { return matches(r) - matches(l); })[0]);
            var nextCamIndex = (currCamIndex + 1) % _this.props.cameras.length;
            return _this.props.cameras[nextCamIndex];
        };
        _this.getCameraThumbnail = function (cameraName) {
            return libzl_1.getCameraThumb(_this.props.buildSession, cameraName !== _this.props.cameras[0], cameraName.split("_")[0]);
        };
        _this.clickedToggle = function () {
            libzl_1.changeCamera(_this.getNextCamera(), _this.changed);
        };
        _this.clickedCopy = function (ev) {
            if (utils_1.copyTextToClipboard(JSON.stringify(libzl_1.captureConfig()))) {
                alert("Copied current metadata to the clipboard!");
            }
            ev.stopPropagation();
        };
        _this.clickedFlyCam = function (ev) {
            libzl_1.changeCamera("CloudFlyCam", function () {
                var streamEl = document.querySelector(".zl-stream-element-wrapper>video");
                console.log("Stream Element:", streamEl);
                streamEl === null || streamEl === void 0 ? void 0 : streamEl.focus();
            });
            ev.stopPropagation();
        };
        _this.clickedToggleMode = function (ev) {
            libzl_1.toggleRenderMode();
        };
        var currentCamera = libzl_1.getCamera();
        _this.state = {
            currentCamera: currentCamera,
            thumbLoaded: false,
            splitButtons: _this.props.cameras.map(function (name, index) { return name === currentCamera ? -1 : index; }).filter(function (i) { return i >= 0; })
        };
        return _this;
    }
    CameraControls.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.cameras.length !== this.props.cameras.length) {
            this.setState(function (prevState) { return ({ splitButtons: _this.props.cameras.map(function (name, index) { return name === prevState.currentCamera ? -1 : index; }).filter(function (i) { return i >= 0; }) }); });
        }
    };
    CameraControls.prototype.render = function () {
        var _this = this;
        var changingMode = this.props.changingMode !== null;
        var name = changingMode ? "Changing" : libzl_1.currently3D() ? "-> 2d" : "-> 3d";
        return (react_1.default.createElement(CameraButtons, null,
            (this.props.cameras.length === 2 || !this.props.split) ?
                react_1.default.createElement(CameraButton_1.default, { onClick: this.clickedToggle, image: this.getCameraThumbnail(this.getNextCamera()) })
                :
                    this.state.splitButtons.map(function (i) { return (react_1.default.createElement(CameraButton_1.default, { onClick: function () { return libzl_1.changeCamera(_this.props.cameras[i], _this.changed); }, image: _this.getCameraThumbnail(_this.props.cameras[i]) })); }),
            utils_1.canUseFlyCam() &&
                react_1.default.createElement(DebugButton, { icon: changingMode ? react_1.default.createElement(components_1.WorkIndicator, null) : undefined, name: name, showName: !changingMode, onClick: function (ev) { _this.clickedToggleMode(ev); }, disabled: changingMode, automationId: "togglemode", taggingOverride: "notag" }),
            (utils_1.canUseFlyCam() && libzl_1.currently3D()) &&
                react_1.default.createElement(components_1.Tooltip, { position: "right", label: "flycam", contents: react_1.default.createElement("table", null,
                        react_1.default.createElement("tbody", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("b", null, "W,S"),
                                    react_1.default.createElement("br", null),
                                    "Dolly"),
                                react_1.default.createElement("td", { rowSpan: 7 },
                                    react_1.default.createElement("img", { width: 460, alt: "camera terms", src: "https://sydneycameraman.files.wordpress.com/2017/07/cameramovement.jpg?w=512" }))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("b", null, "Q,E"),
                                    react_1.default.createElement("br", null),
                                    "Pedestal")),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("b", null, "A,D"),
                                    react_1.default.createElement("br", null),
                                    "Truck")),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("b", null, "I,K"),
                                    react_1.default.createElement("br", null),
                                    "Tilt")),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("b", null, "J,L"),
                                    react_1.default.createElement("br", null),
                                    "Pan")),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("b", null, "U,O"),
                                    react_1.default.createElement("br", null),
                                    "Roll")),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("b", null, "LShift"),
                                    react_1.default.createElement("br", null),
                                    "Slower"))),
                        react_1.default.createElement("tfoot", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", { colSpan: 2, style: { textAlign: "center" } }, "The stream needs to have focus for keyboard controls to work")))), automationId: "flycamerabutton" },
                    react_1.default.createElement(DebugButton, { name: "Free", icon: this.props.theme.svgs.icon_cam_video, showName: true, onClick: function (ev) { _this.clickedFlyCam(ev); }, automationId: "fly_camera", taggingOverride: "notag" })),
            utils_1.canUseFlyCam() &&
                react_1.default.createElement(DebugButton, { name: "Info", icon: this.props.theme.svgs.edit, showName: true, onClick: function (ev) { _this.clickedCopy(ev); }, automationId: "copy_info", taggingOverride: "notag" })));
    };
    return CameraControls;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {
        buildSession: store.BuildSession.current,
        toastQueue: store.ToastMessages.queue,
        thumbs: store.UI.thumbs,
        changingMode: store.UI.changingMode
    };
};
exports.default = react_redux_1.connect(MapStoreToProps)(styled_components_1.withTheme(CameraControls));
var templateObject_1, templateObject_2;
//export default withTheme(CameraControls as any);
//# sourceMappingURL=CameraControls.js.map